<template>
  <p :class="b('', { mix: className, isLeft, isWhite, isMobileView })">
    <!-- Режим редактирования -->
    <a-textarea
      v-if="isEdit"
      :class="b('text-input')"
      placeholder="Enter description text"
      v-model:value="editableText"
      @input="updateText"
      :auto-size="{ minRows: 3, maxRows: 6 }"
    />
    <!-- Обычный режим -->
    <span v-else>
      <slot />
    </span>
  </p>
</template>

<script>
import bem from '@/utils/bem';
import styles from './description-block-style.scss';

const b = bem('description-block', styles);

export default {
  name: 'DescriptionBlock',
  props: {
    className: {
      type: String,
      default: '',
    },
    isLeft: {
      type: Boolean,
      default: false,
    },
    isWhite: {
      type: Boolean,
      default: false,
    },
    isMobileView: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    editText: {
      type: String,
      default: '',
    },
  },
  computed: {
    b() {
      return b;
    },
    editableText: {
      get() {
        return this.editText;
      },
      set(value) {
        this.$emit('update-text', value);
      },
    },
  },
  methods: {
    updateText(event) {
      this.$emit('update-text', event.target.value);
    },
  },
};
</script>
